import apiServiceNew from './apiService.new';

const campaignTrackingPath = 'campaignTracking';

const add = trackingInfo => apiServiceNew.put(campaignTrackingPath, trackingInfo);

const getCampaigns = (campaignParams, selectedPage, rowCount) => apiServiceNew.get(campaignTrackingPath, {
	params : {
		...campaignParams,
		offset: (selectedPage - 1) * rowCount,
		limit: rowCount
	}
});

const getTrackingInfoByAdvisor = campaignParams =>
	apiServiceNew.get(`${campaignTrackingPath}/getTrackingInfoByAdvisor`, {
		params : {
			...campaignParams
		}
	});

const getEmailAnalytics = (id) => apiServiceNew.get(`${campaignTrackingPath}/getEmailAnalytics?campaignID=${id}`);

const getOverallEmailEngagement = (campaignParams, selectedPage, rowCount, isCountRequired) =>
	apiServiceNew.get(`${campaignTrackingPath}/getOverallEmailEngagement?isCountRequired=${isCountRequired}`, {
		params : {
			...campaignParams,
			offset: (selectedPage - 1) * rowCount,
			limit: rowCount
		}
	});

const getRecipientAnalytics = (campaignParams, selectedPage, rowCount) =>
	apiServiceNew.get(`${campaignTrackingPath}/getRecipientAnalytics`, {
		params : {
			...campaignParams,
			offset: (selectedPage - 1) * rowCount,
			limit: rowCount
		}
	});

const getLeadConversionDetails = (campaignParams, selectedPage, rowCount, isCountRequired) => apiServiceNew.get(`${campaignTrackingPath}/getLeadConversionDetails?isCountRequired=${isCountRequired}`, {
	params : {
		...campaignParams,
		offset: (selectedPage - 1) * rowCount,
		limit: rowCount
	}
});

const getLeadConversionExport = (campaignParams, selectedPage, rowCount) =>
	apiServiceNew.get(`${campaignTrackingPath}/getLeadConversionExport`, {
		params : {
			...campaignParams,
			offset: (selectedPage - 1) * rowCount,
			limit: rowCount
		}
	});

const getLandingPageVisits = (campaignParams, isCountRequired) =>
	apiServiceNew.get(`${campaignTrackingPath}/getLandingPageVisits?isCountRequired=${isCountRequired}`, {
		params : {
			...campaignParams
		}
	});

export default {
	add,
	getCampaigns,
	getTrackingInfoByAdvisor,
	getEmailAnalytics,
	getRecipientAnalytics,
	getOverallEmailEngagement,
	getLeadConversionDetails,
	getLandingPageVisits,
	getLeadConversionExport
};